<template>
  <div>
    <div>
      <div class="vx-col w-full">
        <vx-card title="Applicant List">
          <vs-tabs :color="colorx">
            <vs-tab @click="colorx = 'success'" label="Active Applicant List">
              <div class="con-tab-ejemplo">
                <ActiveApplicantList></ActiveApplicantList>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'danger'" label="Blacklisted Applicant List">
              <div class="con-tab-ejemplo">
                <BlackListedApplicantList></BlackListedApplicantList>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'danger'" label="Blocked Applicant List For NID">
              <div class="con-tab-ejemplo">
                <BlockedApplicant></BlockedApplicant>
              </div>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>

    <!--<Guarantor></Guarantor>-->

  </div>
</template>
<script>
  import ActiveApplicantList from './components/ActiveApplicant.vue'
  import BlackListedApplicantList from './components/InactiveApplicant.vue'
  import BlockedApplicant from "./components/BlockedApplicant";
  export default {
    data() {
      return {
        colorx:'success'
      }
    },
    components: {
      ActiveApplicantList,
      BlackListedApplicantList,
      BlockedApplicant
    },

  }
</script>
